import { useEffect, useState } from "react";
import axios from "axios";

const url = `${process.env.GATSBY_CRM_ENDPOINT_URL}houses?fields=basic,urls,facilities`;
const headers = {
  Accept: "application/json",
  Authorization: "Bearer " + process.env.GATSBY_CRM_ENDPOINT_AUTH_TOKEN,
  "Content-Type": "application/json",
};

export default function useCRMData(brand = null) {
  const [crmData, setCrmData] = useState([]);

  useEffect(() => {
    if (!crmData || crmData.length) return;

    axios
      .get(`${url}&perPage=500`, { headers })
      .then(res => res.data.data)
      .then(data => {
        if (brand) {
          data = data.filter(
            pub =>
              pub.brand && pub.brand.name.toLowerCase() === brand.toLowerCase()
          );
        }
        setCrmData(data);
      });
  }, [crmData, brand]);

  return crmData;
}
